import React from 'react'

const PaymentSetting = () => {
  return (
    <>
      <section>
        <h1>Payment Setting</h1>
      </section> 
    </>
  )
}

export default PaymentSetting
